import { BaseComponent } from '../../base-component';
import { scrollTo } from '@otto-ec/global-resources/animation';
import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';

export class QuickAccessComponent extends BaseComponent {
    public rootSelector = '.js_pdp_quick-access';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        this.initExpertReviewLinkClickListener();
    }

    private initExpertReviewLinkClickListener() {
        const expertReviewsLink = this.getRootElement().querySelector('.js_prd_shortInfoExpertReviewsLink');
        if (!expertReviewsLink) {
            return;
        }

        expertReviewsLink.addEventListener('click', () => this.handleExpertReviewLinkClickEvent(expertReviewsLink));
    }

    protected handleExpertReviewLinkClickEvent(expertReviewsLink: Element): void {
        const shouldShowInSheet = expertReviewsLink.getAttribute('data-show-in-sheet') === 'true';
        if (shouldShowInSheet) {
            this.trackJumpMarkClick();
            return;
        }

        const scrollTarget = document.getElementById('js_prd_expertReviewsTarget');
        if (scrollTarget) {
            scrollTo(scrollTarget, 500);
        }

        this.trackJumpMarkClick();
    }

    private trackJumpMarkClick() {
        trackEvent({
            product_JumpMark: ['expertreview'],
        });
    }
}
